'use client';
import HeaderVariety from '../shared/header-variety';
import NavCard from './_NavCard';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

const NavCards = ({ _meta, navCards, title, headerVariation, _testID }) => {
  const footerCards = _meta?.schema?.indexOf('footer') >= 0;
  return (
    <Box
      py={8}
      className={footerCards ? '' : 'rotating-background'}
      sx={{
        backgroundImage: (theme) =>
          footerCards
            ? `linear-gradient(white 25%,white 25%,white 75%,${theme.palette.neutral[900]} 75%)`
            : 'none',
      }}
      data-test-id={`nav_cards_${_testID}`}
    >
      <Container>
        {title && (
          <Box mb={{ xs: 3, md: 4 }} sx={{ textAlign: 'center' }}>
            <HeaderVariety defaultVariation="h2" headerVariation={headerVariation?.headerVariation}>
              {title}
            </HeaderVariety>
          </Box>
        )}
        <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }}>
          {navCards.map((card, i) => (
            <NavCard key={i} {...card} />
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default NavCards;
